import { BarrelOutlineIcon } from './BarrelOutlineIcon';

/**
 * author: Google
 * id DBEE4FC0-D708-4293-B06B-E46FAC217031
 * name barrel-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barrel-outline.svg
 * tags
 */
export const OilBarrelOutlineIcon = BarrelOutlineIcon;
export default OilBarrelOutlineIcon